module.exports = __webpack_public_path__ + "static/media/HeyBookingEng01.9a4a6fa5.png";